import * as React from "react";
import WarehouseInfo from "../../RequestOrderList/WarehouseInfo";
export const WarehousePanel = props => (
  <WarehouseInfo
    pn={props?.record?.pn}
    requestId={props?.record?.id}
    customerCode={props?.record?.customerCode}
    isPbh={true}
  />
);
export default WarehousePanel;
